"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRACKING_ID_PTS = exports.TRACKING_ID_KFS = exports.TRACKING_ID_ETS = exports.PAGE_OBJECT = exports.PAGE_MARKETING = exports.PAGE_FORM = exports.PAGE_DETAIL = exports.PAGE_AD_DETAIL = exports.PAGE_AD_CONFIRMATION = exports.PAGE_ADMIN = exports.ACTION_UNLINK = exports.ACTION_UNHIDE_AD_UNIT = exports.ACTION_SHOW_STATS_UNIT = exports.ACTION_SHOW_MARKETING_OBJECT_PAGE = exports.ACTION_SAVE_UNIT = exports.ACTION_PUBLISH_AD_UNIT = exports.ACTION_PUBLISH_AD = exports.ACTION_LINK_FROM_PTS = exports.ACTION_LINK_FROM_NEW = exports.ACTION_LINK_FROM_KFS = exports.ACTION_HIDE_AD_UNIT = exports.ACTION_GOTO_MARKETING_PAPER = exports.ACTION_GOTO_MARKETING_DIGITAL = exports.ACTION_EDIT_AD_UNIT = exports.ACTION_DELETE_AD_UNIT = exports.ACTION_CREATE_AD_UNIT = exports.ACTION_CONVERT_KFS_TO_PTS = exports.ACTION_CLONE_AD_UNIT = exports.ACTION_CLICK_PROSPECTUS_URL = exports.ACTION_CLICK_PROJECT_URL = exports.ACTION_BLINK_PURCHASED = exports.ACTION_BLINK_MODAL_OPEN = void 0;
var PAGE_OBJECT = 'object-page';
exports.PAGE_OBJECT = PAGE_OBJECT;
var PAGE_DETAIL = 'detail-page';
exports.PAGE_DETAIL = PAGE_DETAIL;
var PAGE_AD_DETAIL = 'detail-page';
exports.PAGE_AD_DETAIL = PAGE_AD_DETAIL;
var PAGE_FORM = 'adin-page';
exports.PAGE_FORM = PAGE_FORM;
var PAGE_ADMIN = 'list-page';
exports.PAGE_ADMIN = PAGE_ADMIN;
var PAGE_AD_CONFIRMATION = 'ad-confirmation-page';
exports.PAGE_AD_CONFIRMATION = PAGE_AD_CONFIRMATION;
var PAGE_MARKETING = 'marketing-page';

// tracking constant values are the same for kfs, pts and units but will not be in the future.
exports.PAGE_MARKETING = PAGE_MARKETING;
var ACTION_PUBLISH_AD_UNIT = 'publish-ad';
exports.ACTION_PUBLISH_AD_UNIT = ACTION_PUBLISH_AD_UNIT;
var ACTION_SAVE_UNIT = 'save-unit';
exports.ACTION_SAVE_UNIT = ACTION_SAVE_UNIT;
var ACTION_PUBLISH_AD = 'publish-ad';
exports.ACTION_PUBLISH_AD = ACTION_PUBLISH_AD;
var ACTION_CREATE_AD_UNIT = 'create-ad';
exports.ACTION_CREATE_AD_UNIT = ACTION_CREATE_AD_UNIT;
var ACTION_CLONE_AD_UNIT = 'clone-unit-ad';
exports.ACTION_CLONE_AD_UNIT = ACTION_CLONE_AD_UNIT;
var ACTION_CONVERT_KFS_TO_PTS = 'create-ad-kfs-to-pts';
exports.ACTION_CONVERT_KFS_TO_PTS = ACTION_CONVERT_KFS_TO_PTS;
var ACTION_DELETE_AD_UNIT = 'delete-ad';
exports.ACTION_DELETE_AD_UNIT = ACTION_DELETE_AD_UNIT;
var ACTION_EDIT_AD_UNIT = 'edit-ad';
exports.ACTION_EDIT_AD_UNIT = ACTION_EDIT_AD_UNIT;
var ACTION_SHOW_STATS_UNIT = 'show-statistics';
exports.ACTION_SHOW_STATS_UNIT = ACTION_SHOW_STATS_UNIT;
var ACTION_SHOW_MARKETING_OBJECT_PAGE = 'show-marketing-platform-adview';
exports.ACTION_SHOW_MARKETING_OBJECT_PAGE = ACTION_SHOW_MARKETING_OBJECT_PAGE;
var ACTION_HIDE_AD_UNIT = 'hide-ad';
exports.ACTION_HIDE_AD_UNIT = ACTION_HIDE_AD_UNIT;
var ACTION_UNHIDE_AD_UNIT = 'unhide-ad';
exports.ACTION_UNHIDE_AD_UNIT = ACTION_UNHIDE_AD_UNIT;
var ACTION_LINK_FROM_PTS = 'link-from-pts';
exports.ACTION_LINK_FROM_PTS = ACTION_LINK_FROM_PTS;
var ACTION_LINK_FROM_KFS = 'link-from-kfs';
exports.ACTION_LINK_FROM_KFS = ACTION_LINK_FROM_KFS;
var ACTION_LINK_FROM_NEW = 'link-from-new-ad';
exports.ACTION_LINK_FROM_NEW = ACTION_LINK_FROM_NEW;
var ACTION_UNLINK = 'unlink';
exports.ACTION_UNLINK = ACTION_UNLINK;
var ACTION_BLINK_MODAL_OPEN = 'order-blink-open';
exports.ACTION_BLINK_MODAL_OPEN = ACTION_BLINK_MODAL_OPEN;
var ACTION_BLINK_PURCHASED = 'order-blink-finish';
exports.ACTION_BLINK_PURCHASED = ACTION_BLINK_PURCHASED;
var ACTION_GOTO_MARKETING_DIGITAL = 'goto-marketing-platform-digital';
exports.ACTION_GOTO_MARKETING_DIGITAL = ACTION_GOTO_MARKETING_DIGITAL;
var ACTION_GOTO_MARKETING_PAPER = 'goto-marketing-platform-paper';
exports.ACTION_GOTO_MARKETING_PAPER = ACTION_GOTO_MARKETING_PAPER;
var ACTION_CLICK_PROSPECTUS_URL = 'show-interest.prospectus-link.click';
exports.ACTION_CLICK_PROSPECTUS_URL = ACTION_CLICK_PROSPECTUS_URL;
var ACTION_CLICK_PROJECT_URL = 'show-interest.project-link.click';
exports.ACTION_CLICK_PROJECT_URL = ACTION_CLICK_PROJECT_URL;
var TRACKING_ID_KFS = 'realestate-planned';
exports.TRACKING_ID_KFS = TRACKING_ID_KFS;
var TRACKING_ID_PTS = 'realestate-development-project';
exports.TRACKING_ID_PTS = TRACKING_ID_PTS;
var TRACKING_ID_ETS = 'realestate-development-single';
exports.TRACKING_ID_ETS = TRACKING_ID_ETS;